module.exports = __webpack_public_path__ + "static/media/video-11-ru.9af44cba.webm";